// this config expects risk() method in main component where product config is being used
export default {
    data() {
        return {
            loadedProduct: null,
        }
    },
    computed: {
        productConfig() {
            if (this.isProductLoaded) {
                return this.product.config;
            }
            return null;
        },
        productQuestions() {
            if (this.isProductLoaded) {
                return this.productConfig.questions;
            }

            return [];
        },
        relatedProperties() {
            if (this.isProductLoaded) {
                return this.productConfig.related_properties;
            }

            return [];
        },
        isProductLoaded() {
            return Boolean(this.product);
        },
        isCommitment() {
            return this.risk.quote_type.key === 'commitment';
        },
        isInvoice() {
            return this.risk.quote_type.key === 'invoice';
        },
        product() {
            if (['commitment', 'invoice'].includes(this.risk.quote_type?.key)) {
                if (this.loadedProduct === null) {
                    this.loadInvoiceCommitment();
                }
                return this.loadedProduct;
            }
                this.loading = false;


            return this.risk.product;
        },
        productKey() {
            if (this.isCommitment || this.isInvoice) {
                return this.risk.quote_type.key;
            }

            return this.risk.product.key;
        },
    },
    methods: {
        isProductDataProperty(question) {
            return question.hasOwnProperty('is_product_data') && question.is_product_data === true;
        },
        isEditable(isAmendment, question) {
            if (!this.isAmendment) {
                return true;
            }

            if (!question.hasOwnProperty('is_amendable')) {
                return true;
            }

            return question.is_amendable === true;
        },
        isTypeRiskPeriod(type) {
            return type === 'risk_period';
        },
        checkPropertyInQuestions(property) {
            return this.productQuestions.find(question => question.field === property);
        },
        checkPropertyInRelatedProperties(property) {
            return this.relatedProperties.find(question => question.field === property);
        },
        productHasProperty(property, isProductData) {
            return this.checkPropertyInQuestions(property) || this.checkPropertyInRelatedProperties(property)
        },
        getQuestionByProperty(property) {
            return this.productQuestions.find(question => question.field === property);
        },
        getQuestionProperty(question) {
            return this.isProductDataProperty(question) ? this.submission.product_data[question.field] : this.submission[question.field];
        },
        getPropertyLabel(property) {
            //check in questions
            let question = this.productQuestions.find(question => question.field === property);

            if (!question) {
                //check in related products
                question = this.relatedProperties.find(question => question.field === property);
            }

            if (question) {
                const testLabel = question.hasOwnProperty('display_label') ? question.display_label : question.label;

                return testLabel;
            }

            return '';
        },
        loadInvoiceCommitment() {
            const dataRequests = [];
            if (this.isCommitment || this.isInvoice) {
                 this.loading = true;

                dataRequests.push(axios.get(this.$root.api(`products/key/${this.productKey}`)).then(res => {
                    this.loadedProduct = res.data.data
                }));

                axios.all(dataRequests).then(() => {
                    this.loading = false;
                });
            }
        },
    }
};
